import { useSelector } from '../../../react-redux';

const UseAdvertise = () => {
  const advertise = useSelector(state => state.getIn(['conversationData', 'advertise']));
  return {
    advertise
  };
};

export default UseAdvertise;
